module.exports = __webpack_public_path__ + "img/img5.63943b63.png";